import { createReducer, on } from '@ngrx/store';
import * as baseState from '../../../core/models/base-state/base-state';
import { PatientGoal } from '../../models/patient-goal';
import * as actions from '../actions/patient-goals.actions';

export const patientGoalsFeatureKey = 'patient-goals';

export interface PatientGoalsState {
  goals: PatientGoal[];
  selectedGoal: PatientGoal | null;
  baseState: baseState.BaseState;
}

export const initialState: PatientGoalsState = {
  goals: [],
  selectedGoal: null,
  baseState: baseState.createBaseState(undefined),
};

export const patientGoalsReducer = createReducer(
  initialState,
  on(
    actions.getPatientGoals,
    (state): PatientGoalsState => ({
      ...state,
      goals: [],
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
    })
  ),
  on(
    actions.getPatientGoalById,
    (state): PatientGoalsState => ({
      ...state,
      selectedGoal: null,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
    })
  ),
  on(
    actions.getPatientGoalsSuccess,
    (state, { goals }): PatientGoalsState => ({
      ...state,
      goals,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    })
  ),
  on(
    actions.getPatientGoalByIdSuccess,
    (state, { goal }): PatientGoalsState => ({
      ...state,
      selectedGoal: goal,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    })
  ),
  on(
    actions.getPatientGoalsFailure,
    (state, { error }): PatientGoalsState => ({
      ...state,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    })
  ),
  on(
    actions.getPatientGoalByIdFailure,
    (state, { error }): PatientGoalsState => ({
      ...state,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    })
  )
);
